import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function DPP() {
  return (
    <div className="min-h-screen bg-white text-[#0a0a0a]">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Digital Product Passport (DPP)</h1>
            <p className="text-lg text-[#64748b] mb-12">
              Strategic advisory for Digital Product Passport readiness and AAS framework adoption.
            </p>
            
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4">About DPP</h2>
                <p className="text-[#64748b] mb-6">
                  The Digital Product Passport (DPP) is a key component of the European Union's 
                  circular economy strategy, enabling traceability and transparency throughout 
                  product lifecycles.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">Our Services</h2>
                <p className="text-[#64748b] mb-6">
                  We provide expert guidance for DPP implementation using AAS standards and 
                  IDTA specifications.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
                <p className="text-[#64748b] mb-4">
                  For DPP consultation inquiries, please contact us at:
                </p>
                <p className="text-[#64748b]">
                  Email: <a href="mailto:info@idtwin.org" className="text-[#0028CD] hover:underline">info@idtwin.org</a><br />
                  Phone: +49 69 6603 1939
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default DPP;
